import React from 'react';

import {AutoArchiveBanner} from './AutoArchiveBanner';
import {LicenseBanners} from './LicenseBanners';

export const HomeBanners = () => (
  <div aria-live='polite' className='flex flex-col gap-x1-half empty:hidden'>
    <LicenseBanners />
    <AutoArchiveBanner />
  </div>
);
